import styled from 'styled-components';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

export const Placeholder = styled.div`
    text-align: center;
    height: 100%;
    color: ${getColor('inputTextColor')};
    font-family: ${getFontFamily('atlassian')};
    font-size: ${getFontSize('smaller')};
    letter-spacing: ${getLetterSpacing('input')};
    line-height: ${getLineHeight('small')};
`;
